var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"feedback"},[_c('p',{staticClass:"feedback__text"},[_vm._v(" "+_vm._s(_vm._text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }